import { render, staticRenderFns } from "./EntityBadgeError.vue?vue&type=template&id=08f25aea&scoped=true"
import script from "./EntityBadgeError.vue?vue&type=script&lang=js"
export * from "./EntityBadgeError.vue?vue&type=script&lang=js"
import style0 from "./EntityBadgeError.vue?vue&type=style&index=0&id=08f25aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f25aea",
  null
  
)

export default component.exports